import { Component, Input } from '@angular/core';
import { SalvageTabContext } from '../salvage-tab-context';

@Component({
  selector: 'app-salvage-inventory-tab',
  templateUrl: './salvage-inventory-tab.component.html',
})
export class SalvageInventoryTabComponent {
  @Input() context!: SalvageTabContext;
}
